import { CFB_INTEGRATION_STATE_PORT } from '@cigna/cigna-for-brokers/shared/util';
import { AppService } from './+state/app.service';

export const CFB_INTEGRATION_STATE_PROVIDER = {
  provide: CFB_INTEGRATION_STATE_PORT,
  useExisting: AppService,
};
